import React from 'react'
import {Box, Button, Typography} from '@mui/material'
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined'
import styles from './styles'

export type FileDetailsProps = {
  name: string
  sizeLabel: string
  onRemove: () => void
  helperText?: string
  disabled?: boolean
}

const FileDetails: React.FC<FileDetailsProps> = ({
  name,
  sizeLabel,
  onRemove,
  helperText,
  disabled = false,
}) => {
  return (
    <Box sx={styles.container}>
      <Box sx={styles.header}>
        <Box sx={styles.meta}>
          <InsertDriveFileOutlinedIcon color="primary" />
          <Box>
            <Typography variant="subtitle1">{name}</Typography>
            <Typography variant="body2" sx={styles.metaText}>
              {sizeLabel}
            </Typography>
          </Box>
        </Box>
        <Button
          color="secondary"
          onClick={onRemove}
          size="small"
          disabled={disabled}
          aria-disabled={disabled}>
          Remove
        </Button>
      </Box>
      {helperText && (
        <Typography variant="body2" sx={styles.helperText}>
          {helperText}
        </Typography>
      )}
    </Box>
  )
}

export default FileDetails
